export LogoRamon from './LogoRamon';
export LogoTimur from './LogoTimur';
export LogoProduct from './LogoProduct';
export LogoPm from './LogoPm';
export LogoDesign from './LogoDesign';
export LogoFront from './LogoFront';
export LogoCore from './LogoCore';
export LogoInegration from './LogoInegration';
export LogoQa from './LogoQa';
export LogoDevops from './LogoDevops';
export LogoPromo from './LogoPromo';
export LogoOperation from './LogoOperation';
export LogoMarketing from './LogoMarketing';
export LogoSmm from './LogoSmm';



// WEBPACK FOOTER //
// ../components/SVG/index.js